import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import { Person, ExitToApp, ManageAccounts, Security } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';

function UserMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const { logout, checkRole } = useAuth();
  const isGodOrAdmin = checkRole('god') || checkRole('admin');

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await logout();
      handleClose();
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  return (
    <div>
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
        className="user-menu-button"
        sx={{
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }
        }}
      >
        <Person 
          fontSize="large" 
          sx={{ 
            color: '#E5E7EB',
            '&:hover': {
              color: '#FFFFFF'
            }
          }} 
        />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            backgroundColor: '#FFFFFF',
            color: '#1F2937',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
            minWidth: '200px',
            mt: 1
          }
        }}
      >
        {isGodOrAdmin && (
          <MenuItem
            component={Link}
            to="/user-management"
            onClick={handleClose}
            sx={{
              '&:hover': {
                backgroundColor: '#F3F4F6'
              }
            }}
          >
            <ListItemIcon>
              <ManageAccounts fontSize="small" sx={{ color: '#2196F3' }} />
            </ListItemIcon>
            <ListItemText primary="Manage Users" />
          </MenuItem>
        )}
        <MenuItem
          component={Link}
          to="/mfa-setup"
          onClick={handleClose}
          sx={{
            '&:hover': {
              backgroundColor: '#F3F4F6'
            }
          }}
        >
          <ListItemIcon>
            <Security fontSize="small" sx={{ color: '#16A34A' }} />
          </ListItemIcon>
          <ListItemText primary="Security" />
        </MenuItem>
        <MenuItem
          onClick={handleLogout}
          sx={{
            '&:hover': {
              backgroundColor: '#F3F4F6'
            }
          }}
        >
          <ListItemIcon>
            <ExitToApp fontSize="small" sx={{ color: '#EF4444' }} />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </MenuItem>
      </Menu>
    </div>
  );
}

export default UserMenu;
